import { render, staticRenderFns } from "./NjDialog.vue?vue&type=template&id=51f07832&scoped=true"
import script from "./NjDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./NjDialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./NjDialog.vue?vue&type=style&index=0&id=51f07832&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f07832",
  null
  
)

export default component.exports